import { klaviyoConfig } from "@/lib/klaviyo-client/klaviyo-config"

export const fieldPlaceholder: Map<string, string> = new Map()

fieldPlaceholder.set("Email", "e.g. name@pocsports.com")
fieldPlaceholder.set("Firstname", "e.g. Adam")
fieldPlaceholder.set("Lastname", "e.g. Smith")
fieldPlaceholder.set("address1", "e.g. 1234 Main St")
fieldPlaceholder.set("zipCode", "e.g. 00000")
fieldPlaceholder.set("city", "e.g. Berlin")
fieldPlaceholder.set("phoneNumber", "e.g. +000 123 456 7890")

export const fieldLabel = new Map<string, string>()

fieldLabel.set("email", "checkout.information_for_billing_and_shipping.email")
fieldLabel.set("first_name", "checkout.information_for_billing_and_shipping.first_name")
fieldLabel.set("last_name", "checkout.information_for_billing_and_shipping.last_name")
fieldLabel.set("address1", "checkout.information_for_billing_and_shipping.address")
fieldLabel.set("address2", "checkout.information_for_billing_and_shipping.address_line_2")
fieldLabel.set("zipCode", "checkout.information_for_billing_and_shipping.zip_code")
fieldLabel.set("city", "checkout.information_for_billing_and_shipping.city")
fieldLabel.set("state", "checkout.information_for_billing_and_shipping.state")
fieldLabel.set(
    "phoneNumber",
    "checkout.information_for_billing_and_shipping.phone_number"
)

// Convert the klaviyoFormCodes object into a Map
const isProduction = process.env.NEXT_PUBLIC_KLAVIYO_ID === "R8UBuv"
const environment = isProduction ? "production" : "qa"
export const klaviyoFormCodesMap: Map<string, string> = new Map(
    Object.entries(klaviyoConfig.checkoutMembershipForm[environment])
)
